import { routes } from '@/app/routing/router'
import { StartPage } from './view'

const currentRoute = routes.start

const StartPageRoute = {
  view: StartPage,
  route: currentRoute,
}

export { currentRoute, StartPageRoute }
